/*
 *@Description:缓存工具库
 *@Author: zhengff
 *@Date: 2019-04-21 22:57:38
*/
import BASE from './base'
/**
 * 缓存
 * @type {Object}
 */
const CACHE = {
  isString: function (v) {
    return Object.prototype.toString.call(v) == '[object String]';
  },
  get: function (key) {
    var val = localStorage.getItem(key),
      res;
    if (val) {
      try {
        res = JSON.parse(val);
      } catch (e) {
        res = val;
      }
    }
    if (res && res.__TYPE == 'ISS_T_CACHE') {
      if (res.type == 'OBJECT') {
        try {
          res = JSON.parse(res.value);
        } catch (e) {
          res = res.value;
        }
      } else {
        res = res.value;
      }
    }
    return res;
  },
  put: function (key, value) {
    key += '';
    var cacheItem;
    if (!BASE.isString(value)) {
      try {
        cacheItem = {
          __TYPE: 'ISS_T_CACHE',
          type: 'OBJECT',
          value: JSON.stringify(value)
        };
      } catch (e) {
        cacheItem = {
          __TYPE: 'ISS_T_CACHE',
          type: 'OBJECT',
          value: (value = value ? value.toString() : '')
        };
      }
    } else {
      cacheItem = {
        __TYPE: 'ISS_T_CACHE',
        type: 'STRING',
        value: value
      };
    }
    return localStorage.setItem(key, JSON.stringify(cacheItem));
  },
  remove: function (key) {
    var res = this.get(key);
    localStorage.removeItem(key);
    return res;
  },
  clear: function () {
    localStorage.clear();
  }
}
export default CACHE;